import { render } from "./BaseButtonPrimary.vue?vue&type=template&id=559f3168"
import script from "./BaseButtonPrimary.vue?vue&type=script&lang=js"
export * from "./BaseButtonPrimary.vue?vue&type=script&lang=js"

import exportComponent from "/Users/filip/coding/shean/reklamace/reklamace-fe-slovakova/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__